var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }